import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { Models } from 'models/core';
import { ErrorService } from 'services/error-service';
import { GeneralOfferTypeService } from 'services/general-offer-type-service';
import { ToastService } from 'services/toast-service';

@autoinject
export class GeneralOfferTypeList {
  private tableData: Array<Models.GeneralOfferType>;
  private activeTableRow: number;

  private constructor(
    private errorService: ErrorService,
    private eventAggregator: EventAggregator,
    private router: Router,
    private toastService: ToastService,
    private generalOfferTypeService: GeneralOfferTypeService
  ) {}

  private activate(params) {
    if (params.Id) {
      this.activeTableRow = params.Id;
    } else {
      this.activeTableRow = 0;
    }
  }

  private attached(params) {
    this.eventAggregator.subscribe('generalOfferTypeListReset', (value) => {
      this.activeTableRow = null;
      return this.updateView();
    });
    this.updateView();
  }

  private updateView() {
    this.generalOfferTypeService
      .getAll('?$orderby=Name&$expand=Segment')
      .then((res) => {
        this.tableData = res;
      })
      .catch((err) => this.errorService.handleError(err));
  }

  private gotoDetailView(id) {
    this.activeTableRow = id;
    this.router.navigateToRoute('general-offer-type-detail', { Id: id });
  }
}
